<template>
	<div :class="classes">
		<div class="teammate-popunder__item"
			v-for="teammate in teammates" :key="teammate.id"
			@click="$emit( `select`, teammate )"
		>
			<div class="teammate-popunder__avatar">
				<UserAvatar :user="teammate" />
			</div>
			<label>{{ teammate.displayName }}</label>
		</div>
	</div>
</template>

<script>
import UserAvatar from "../UserAvatar";

export default {
	name: "TeammatePopunder",
	components: {
		UserAvatar,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		teammates: {
			type: Array,
			required: true,
		},
		isVisible: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		classes() {
			return {
				"teammate-popunder": true,
				"teammate-popunder--visible": this.isVisible,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.teammate-popunder {
	display: none;
	flex-direction: column;

	position: absolute;
	top: 0;
	z-index: 999;
	background-color: $teammate-popunder-background-color;

	border-radius: 0.5rem;
	border: 0.0625rem solid $teammate-popunder-border-color;

	width: 100%;
	@include auto-y-scroll();

	box-shadow: 0 2.1875rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2), 0 0.1875rem 0.375rem rgba(33, 45, 99, 0.15);
}

.teammate-popunder--visible {
	display: flex;
}

.teammate-popunder__item {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;

	padding: 0.5rem 0.5rem 0 0.5rem;

	&:last-of-type {
		padding-bottom: 0.5rem;
	}

	&:hover {
		background-color: $teammate-popunder-item-hover-color;
	}
}

.teammate-popunder__avatar {
	margin-right: 0.5rem;
}
</style>
